// // project import
// import dashboard from './dashboard';
// import userMaster from './userMaster'
// import masterData from './masterData'
// import report from './reports'
// import approval from './approval'
// import documents from './documents';

// // ==============================|| MENU ITEMS ||============================== //

// const userMasterMenu = userMaster();
// const reportsMenu = report();
// const documentsMenu = documents();
// const masterMenu = masterData();
// const ordersMenu = orders();

// const menuItems = {
//   items: [dashboard,userMasterMenu,masterMenu,reportsMenu,approval,documentsMenu,ordersMenu]
// };

// export default menuItems;




// // project import
// import dashboard from './dashboard';
// import userMaster from './userMaster'
// import masterData from './masterData'
// import report from './reports'
// import approval from './approval'
// import documents from './documents'
// import orders from './orders';

// // ==============================|| MENU ITEMS ||============================== //

// const menuItems = {
//   items: [dashboard,userMaster,masterData,report,approval,documents,orders]
// };

// export default menuItems;





// import { useAuth } from '../sections/auth/AuthContext';
// import dashboard from './dashboard';
// import userMaster from './userMaster';
// import masterData from './masterData';
// import report from './reports';
// import approval from './approval';
// import documents from './documents';
// import orders from './orders';

// const useMenuItems = () => { //useMenuItems
//   const { userInfo } = useAuth();
//   const roleID = userInfo?.roleID;

//   const userMasterMenu = userMaster(roleID);
//   const reportsMenu = report(roleID);
//   const documentsMenu = documents(roleID);
//   const masterMenu = masterData(roleID);
//   const ordersMenu = orders(roleID);

//   return {
//     items: [dashboard, userMasterMenu, masterMenu, reportsMenu, approval, documentsMenu, ordersMenu]
//   };
// };

// export default useMenuItems;









import { useAuth } from '../sections/auth/AuthContext';
import dashboard from './dashboard';
import userMaster from './userMaster';
import masterData from './masterData';
import reports from './reports';
import approval from './approval';
import documents from './documents';
import orders from './orders';
import { filterByRole } from '../utils/common';

// const useMenuItems = () => {
//   const { userInfo } = useAuth();
//   const roleID = userInfo?.roleID;

//   return {
//     items: [
//       dashboard,
//       userMaster(roleID),
//       // masterData(roleID),
//       // report(roleID),
//       // approval,
//       // documents(roleID),
//       // orders(roleID)
//     ]
//   };
// };



const useMenuItems = () => {
  const { userInfo } = useAuth();
  const roleID = Number(userInfo?.roleID);

  const filteredItems = [
    filterByRole(dashboard, roleID),
    filterByRole(userMaster, roleID),
    filterByRole(masterData, roleID),
    filterByRole(reports, roleID),
    filterByRole(approval, roleID),
    filterByRole(documents, roleID),
    filterByRole(orders, roleID)
  ].filter(item => item && item.children?.length > 0);

  return { items: filteredItems };
};
export default useMenuItems;
